 export  const categoryEN = {
  "categoryConfig": {
    "header": {
      "bonusMethod": "Bonus Method",
      "reprimandMethod": "Reprimand Method",
      "receiptProcedures": "Receipt Procedures",
      "severanceProcedures": "Severance Procedures",
      "add": "Add Category",
      "update": "Update Category",
      "category" : "Category",
      "addBonusMethod": " Add Bonus Method",
      "addReprimandMethod": "Add Reprimand Method",
      "addReceiptProcedures": "Add Receipt Procedures",
      "addSeveranceProcedures": "Add Severance Procedures",
      "updateBonusMethod": "Update Bonus Method",
      "updateReprimandMethod": "Update Reprimand Method",
      "updateReceiptProcedures": "Update Receipt Procedures",
      "updateSeveranceProcedures": "Update Severance Procedures "
    },
    "title": {
      "name": "Name",
      "description": "Description"
    },
    "placeHolder": {
      "name": "Enter Name",
      "description": "Enter Description"
    },
    "message": {
      "add": "Add Success",
      "update": "Update Success",
      "delete": "Delete Success"
    },
    "btn": {
      "add": "Add",
      "update": "Update",
      "delete": "Delete"
    }

  }
}